// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenuButton-cls1__d866cfb90065c031fd43{/*!*/}.AccountMenuButton-cls2___c05eb4c5cab12cab1ef{width:26px;height:26px;border-radius:50%;margin-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenuButton-cls1__d866cfb90065c031fd43",
	"cls2": "AccountMenuButton-cls2___c05eb4c5cab12cab1ef AccountMenuButton-cls1__d866cfb90065c031fd43"
};
export default ___CSS_LOADER_EXPORT___;
